import { SCMAuthentication, type SCMAuthenticationModalProps } from "@/routes/environments/create/SCMAuthentication";
import { useSCMAuthentication } from "@/hooks/use-scm-authentication.ts";
import { type FC } from "react";

export const Authentication: FC<SCMAuthenticationModalProps> = (p) => {
    const props = useSCMAuthentication({
        repoURL: p.repoURL,
        authenticationUrl: p.authenticationUrl,
        runnerId: p.runnerId,
    });
    return <SCMAuthentication {...{ ...p, ...props }} />;
};
